import type { ContactDetails, OptionalRemittanceConfig } from "./types";

/**
 * Default contact details (empty values to force explicit configuration)
 */
export const defaultContactDetails: ContactDetails = {
  supportEmail: "",
  supportPhone: {
    display: "",
    value: "",
  },
  infoEmail: "",
  whatsappNumber: "",
};

/**
 * Default values for optional configuration.
 * These are merged with client-provided required values.
 */
export const defaultOptionalConfig: OptionalRemittanceConfig = {
  contactDetails: defaultContactDetails,
};
